<div class="sidebar-item text-white" 
  [ngbTooltip]="hideContent ? title : ''"
  placement="right"
  [ngClass]="{'disabled': disabled, 'indented': indented}">
  <div class="icon-wrapper">
    <fa-icon *ngIf="icon" [icon]="icon" size="lg"></fa-icon>
    <ng-content></ng-content>
  </div>
  <div *ngIf="!hideContent" class="title">{{title}}</div>
</div>